import type {
  LoaderFunction,
  ShouldRevalidateFunctionArgs,
} from 'react-router-dom';
import { redirect } from 'react-router-dom';

let currentOrganizationId: string | undefined = undefined;

export const craLoader: LoaderFunction = ({ params }) => {
  const { organizationId } = params;

  if (currentOrganizationId && currentOrganizationId !== organizationId) {
    currentOrganizationId = organizationId;
    return redirect(`/${organizationId}/cyber-resilience-assessment/dashboard`);
  }

  currentOrganizationId = organizationId;

  return null;
};

export function shouldRevalidateAssessment({
  currentParams,
  nextParams,
  defaultShouldRevalidate,
}: ShouldRevalidateFunctionArgs) {
  if (currentParams.organizationId !== nextParams.organizationId) {
    return true;
  }
  return defaultShouldRevalidate;
}
